import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Switch,
  TextField,
} from '@mui/material'

export type ManufacturerFormType = {
  office: string
  cooperIdx: number | ''
  cooperName: string
  active: boolean
}

export type ManufacturerFormErrorsType = {
  cooperIdx: string
  cooperName: string
}

type Props = {
  open: boolean
  form: ManufacturerFormType
  errors: ManufacturerFormErrorsType
  onClose: () => void
  onChange: (field: keyof ManufacturerFormType, value: string | boolean | number) => void
  onSubmit: () => void
}

const ManufacturerFormDialog = ({open, form, errors, onClose, onChange, onSubmit}: Props) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth='sm'>
      <DialogTitle>제조사 등록</DialogTitle>

      <DialogContent>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            pt: 1,
          }}
        >
          <TextField label='사업소 코드' value={form.office} fullWidth disabled />

          <TextField
            label='제조사 번호'
            type='number'
            value={form.cooperIdx}
            onChange={(e) => {
              const value = e.target.value

              onChange('cooperIdx', value === '' ? '' : Number(value))
            }}
            error={Boolean(errors.cooperIdx)}
            helperText={errors.cooperIdx}
            fullWidth
            inputProps={{
              min: 1,
            }}
          />

          <TextField
            label='제조사명'
            value={form.cooperName}
            onChange={(e) => onChange('cooperName', e.target.value)}
            error={Boolean(errors.cooperName)}
            helperText={errors.cooperName}
            fullWidth
          />

          <FormControlLabel
            control={
              <Switch
                checked={form.active}
                onChange={(e) => onChange('active', e.target.checked)}
                color='success'
              />
            }
            label='사용'
          />
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color='inherit'>
          취소
        </Button>

        <Button onClick={onSubmit} variant='contained'>
          등록
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ManufacturerFormDialog
